module.exports = __webpack_public_path__ + "img/icn_remark.122f0bb5.svg";